import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../../hooks/useTheme.js';
import { Box } from '../../Box/index.js';
import { useMainNavContext } from '../MainNavContext/index.js';

var MainNavSection = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var themeKey = useMainNavContext().themeKey;
    var forwardProps = handleStyleProps(props, {
        themeKey: "".concat(themeKey, "Section"),
    });
    return (jsx(Box, __assign({ "data-nav-section": true }, forwardProps, { children: children })));
};

export { MainNavSection };
//# sourceMappingURL=index.js.map
